import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const productData = [
  { image: "/gt.png", title: "Product 1", bgColor: "#435d6f" },
  { image: "/fm.png", title: "Product 2", bgColor: "#5A7991" },
  { image: "/aa.png", title: "Product 3", bgColor: "#6E8DA4" },
  { image: "/bhp.png", title: "Product 4", bgColor: "#829EB4" },
  { image: "/bhp2.png", title: "Product 5", bgColor: "#97B2C5" },
  { image: "/image.png", title: "Product 6", bgColor: "#AEC5D6" },
];

const Home = () => {
  const navigate = useNavigate(); // Initialize navigate

  // Function to handle button click
  const handleSeeProducts = () => {
    navigate("/products"); // Navigate to the products page
  };

  return (
    <div className="container py-5">
      <div className="row align-items-center">
        {/* Left Section */}
        <div className="col-md-6 text-center text-md-start">
          <h1 className="fw-bold text-dark">
            Welcome to <br /> <span className="text-primary">Mediasha Services <br/> Private Ltd.</span>
          </h1>
          <p className="text-muted mt-3">
            Mediasha Services Pvt. Ltd. has a vision to provide a vital link
            between Health Care and technology. With this vision, Mediasha
            Services Pvt. Ltd. offers time-tested international quality products
            and services to our clients at affordable prices with excellent
            support.
          </p>
          <button 
            className="btn btn-primary mt-3 shadow-lg px-4 py-2"
            onClick={handleSeeProducts} // Add onClick event
          >
            SEE PRODUCTS
          </button>
        </div>

        {/* Right Section - Products */}
        <div className="col-md-6 mt-4 mt-md-0">
          <div className="row g-3">
            {productData.map((product, index) => (
              <div key={index} className="col-6 col-md-4">
                <div
                  className="p-3 rounded shadow-lg text-center book-card"
                  style={{
                    background: `linear-gradient(135deg, ${product.bgColor}, #ffffff20)`,
                    height: "180px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "15px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  }}
                >
                  <img
                    src={product.image}
                    alt={product.title}
                    className="img-fluid shadow"
                    style={{
                      maxWidth: "80%",
                      maxHeight: "95%",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CSS for hover effects */}
      <style>{`
        .book-card:hover {
          transform: scale(1.05);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        }
        .book-card:hover img {
          transform: scale(1.1);
        }
      `}</style>
    </div>
  );
};

export default Home;
